import DOMPurify from 'dompurify';
import { constants } from '@wsb/guac-widget-core';

const {
  matcher: { URL }
} = constants;

export const isValidFeedUrl = url => {
  const regex = new RegExp(URL, 'i');
  return regex.test(url);
};

export const secondsToHms = seconds => {
  return new Date(seconds * 1000).toISOString().substr(11, 8);
};

export const postFormatDate = (published, region = 'en-US') => {
  const date = new Date(published);
  return date.toLocaleDateString(region, {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
};

export const isValidPodcast = podcast => {
  return Boolean(
    Object.keys(podcast).length > 0 &&
      podcast?.episodes?.length > 0 &&
      podcast?.episodes[0]?.enclosure
  );
};

export const formatData = data => {
  return {
    ...data,
    description: {
      long: DOMPurify.sanitize(data.description.long)
    },
    episodes: data.episodes.map(episode => {
      return {
        ...episode,
        image: episode.image || data.image,
        description: DOMPurify.sanitize(episode.description)
      };
    })
  };
};

export const initStaticFeedData = (data, businessName) => {
  data.title = businessName;
  data.image = 'https://img1.wsimg.com/isteam/stock/10626';

  data.episodes = data.episodes.map((episode, i) => {
    var date = new Date();
    date.setDate(date.getDate() - i * 7);
    episode.published = date;

    episode.enclosure = {
      filesize: 100,
      type: 'audio/mpeg',
      url: ''
    };
    return episode;
  });
  return data;
};

export const trimText = (text, maxLength) => {
  if (text.length <= maxLength) return text;

  const trimmed = text.substr(0, maxLength);
  if (text.charAt(maxLength) === ' ') {
    return trimmed;
  }

  return trimmed.substr(0, trimmed.lastIndexOf(' '));
};
